import { createAction } from 'Lib/reduxUtils';

import {
  ADD_NOTIFICATION,
  HIDE_ADD_TO_HOMESCREEN_IOS_TOOLTIP,
  NOTIFICATIONS_CHECK,
  NOTIFICATIONS_SUBSCRIBE,
  NOTIFICATIONS_SUBSCRIBE_SUCCESS,
  NOTIFICATIONS_UNSUBSCRIBE,
  NOTIFICATIONS_UNSUBSCRIBE_SUCCESS,
  REMOVE_NOTIFICATION,
  REPLY_REMINDER_SHOWN,
  REQUEST_NOTIFICATIONS_PERMISSION,
  RESET_NOTIFICATIONS,
  SHOW_ADD_TO_HOMESCREEN_IOS_TOOLTIP,
  SHOW_HOMESCREEN_PROMPT,
  SHOW_NOTIFICATION,
  TINDER_SUBSCRIBE_SUCCESS,
  TINDER_UNSUBSCRIBE_SUCCESS,
  UPDATE_NOTIFICATIONS_TYPE,
} from './constants';
import type { NotificationItem, NotificationState, NotificationType } from './types';

export const notificationsCheck = createAction(NOTIFICATIONS_CHECK);
export const requestNotificationsPermission = createAction(REQUEST_NOTIFICATIONS_PERMISSION);

export const addNotification = createAction(
  ADD_NOTIFICATION,
  ({
    title,
    body,
    icon,
    theme,
    target,
    context,
    options,
    timestamp,
    role,
  }: Partial<NotificationItem>) => ({
    body,
    context,
    icon,
    options,
    target,
    title,
    theme,
    timestamp,
    role,
  })
);

export const showNotification = createAction(
  SHOW_NOTIFICATION,
  ({ body, category, context, icon, options, role, title, theme }: Partial<NotificationItem>) => ({
    body,
    category,
    context,
    icon,
    options,
    role,
    title,
    theme,
  })
);

export const removeNotification = createAction(
  REMOVE_NOTIFICATION,
  (timestamp: NotificationItem['timestamp']) => ({
    timestamp,
  })
);

/**
 * Updates the notification type (browser or in-app)
 *
 * When the app is active, we display an in-app notification. Otherwise, we use the native browser
 * notification to get the user's attention.
 */
export const resetNotifications = createAction(RESET_NOTIFICATIONS);

export const updateNotificationsType = createAction(
  UPDATE_NOTIFICATIONS_TYPE,
  (type: NotificationType) => ({
    type,
  })
);

export const notificationsSubscribe = createAction(NOTIFICATIONS_SUBSCRIBE);
export const notificationsUnsubscribe = createAction(NOTIFICATIONS_UNSUBSCRIBE);

export const notificationsSubscribeSuccess = createAction(NOTIFICATIONS_SUBSCRIBE_SUCCESS);
export const notificationsUnsubscribeSuccess = createAction(NOTIFICATIONS_UNSUBSCRIBE_SUCCESS);

export const tinderSubscribeSuccess = createAction(
  TINDER_SUBSCRIBE_SUCCESS,
  (pushId: NotificationState['pushId']) => ({
    pushId,
  })
);
export const tinderUnsubscribeSuccess = createAction(TINDER_UNSUBSCRIBE_SUCCESS);
export const showBrowserHomescreenPrompt = createAction(SHOW_HOMESCREEN_PROMPT);
export const setReplyReminderAsShown = createAction(REPLY_REMINDER_SHOWN);
export const showAddToHomescreenIosTooltip = createAction(SHOW_ADD_TO_HOMESCREEN_IOS_TOOLTIP);
export const hideAddToHomescreenIosTooltip = createAction(HIDE_ADD_TO_HOMESCREEN_IOS_TOOLTIP);
